import React from 'react'
import { LogoVend } from '~misc/icons'

const DeviceBlocked = ({ device = [] }) => {
  const devicesText =
    device.length > 1
      ? device.slice(0, -1).join(', ') + ' ou ' + device.slice(-1)
      : device[0];

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-4">
      <div className="mb-4">
        <LogoVend className="flex-shrink-0 flex-grow-0 basis-full logo" />
      </div>

      <h1 className="text-2xl font-bold text-primaria ">
        DISPOSITIVO NÃO AUTORIZADO
      </h1>

     <p>
        Esse dispositivo não tem permissão para acessar o sistema. Acesse via {devicesText}.<br />
        Em caso de dúvidas, entre em contato com o suporte.
      </p>
    </div>
  )
}

export default DeviceBlocked
